import React from "react";

const DevelopmentFinanceGuide = () => {
  return <div>DevelopmentFinanceGuide</div>;
};

export default DevelopmentFinanceGuide;
